module.exports = __webpack_public_path__ + "static/Oss-FB-3-f633e034063fe1b5caf56acf1faaeaf4.png";